import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import logoWC from '../images/btWelcome.png';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';


class LoginWelcomeCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBtLogin: true, 
      showLoading: false, 
      urlWCSuperior:'http://www.exactosignagesolutions.com/pms/index.php/login/autentificacionUserAPI',
      urlWCSuperiorForm:'http://www.exactosignagesolutions.com/pms/index.php/login/autentificacionUser2020',
      urlWCStick:'http://www.exactosignagesolutions.com/welcomecenterstick/index.php/login/autentificacionUserAPI',
      urlWCStickForm:'http://www.exactosignagesolutions.com/welcomecenterstick/index.php/login/autentificacionUser2020',
      urlWCGlobal:'http://',
      urlWCGlobalForm:'http://',
      urlWCMenu:'http://',
      urlWCMenuForm:'http://',      
      wcUser:'',
      wcPass:'',
      currentFormURL:'',
    };

    // This binding is necessary to make `this` work in the callback
    this.handleClickLogin = this.handleClickLogin.bind(this);    
    this.inputWCStick = React.createRef();
    this.inputWCSuperior = React.createRef();
    this.inputWCGlobal = React.createRef();
    
  }
  handleClickLogin() {
    console.log("Clicked Button");
    this.setState({ showLoading: true });  
    this.setState({ showBtLogin: false });
    console.log(" User is" + this.state.wcUser); 
    this.loginWCStick();
}

getData() {
  console.log("DATA POST");
  // create a new XMLHttpRequest
  var xhr = new XMLHttpRequest();

  // get a callback when the server responds
  xhr.addEventListener('load', () => {
    // update the state of the component with the result here
    console.log("RESP" + xhr.responseText);
    var respuestaPeticion=xhr.responseText;
    if(respuestaPeticion=="True"){
      console.log("CORRECT ACCESS");
      this.setState({ currentFormURL: this.state.urlWCStickForm});
      this.inputWCStick.current.click();
    }else
    {
      console.log("INCORRECT ACCESS");
      this.setState({ currentFormURL: 'ACCES DENIED'});
      this.getDataSuperior();
    }
  })
  // open the request with the verb and the url
  xhr.open('POST', 'http://www.exactosignagesolutions.com/welcomecenterstick/index.php/login/autentificacionUserAPI')
  // send the request
  xhr.send(JSON.stringify({ usuario: this.state.wcUser,pass:this.state.wcPass }))  
  //console.log(xhr.responseText);
  
}
getDataSuperior() {
  console.log("DATA POST");
  // create a new XMLHttpRequest
  var xhr = new XMLHttpRequest();

  // get a callback when the server responds
  xhr.addEventListener('load', () => {
    // update the state of the component with the result here
    console.log("RESP" + xhr.responseText);
    var respuestaPeticion=xhr.responseText;
    if(respuestaPeticion=="True"){
      console.log("CORRECT ACCESS");
      this.setState({ currentFormURL: this.state.urlWCSuperiorForm});
      this.inputWCStick.current.click();
    }else
    {
      console.log("INCORRECT ACCESS");
      this.setState({ currentFormURL: 'ACCES DENIED'});
    }
  })
  // open the request with the verb and the url
  xhr.open('POST', 'http://www.exactosignagesolutions.com/pms/index.php/login/autentificacionUserAPI')
  // send the request
  xhr.send(JSON.stringify({ usuario: this.state.wcUser,pass:this.state.wcPass }))  
  //console.log(xhr.responseText);
  
}





async loginWCStick() {
  this.getData();
  /*
  const url=this.state.urlWCStick;  
  //mode: "no-cors",
  const requestOptions = {
    method: 'POST',
    
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ usuario: 'polo',pass:'polo' })
};


  const response = await fetch(url,requestOptions);
  //const users = await response.json();
  console.log(response);
*/
  this.setState({ showLoading: false });
  this.setState({ showBtLogin: true });
  
  //const users = await response.json();
  //console.log(users);
  //document.location.href = "http://www.exactosignagesolutions.com/welcomecenterstick/index.php/managementClient/index";
  
  //setUsers(users);
}

    render() {
        const mystyle = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial",
            width:'400px',
          };

        return (
          <div> 
           <MetaTags>
            <title>Welcome Center Login</title>
            <meta id="meta-description" name="description" content="Exacto Signage Welcome Center" />
            <meta id="og-title" property="og:title" content="MyApp" />
            <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />             
          </MetaTags>     
          <Container maxWidth="sm">
            <img src="http://exactosignagesolutions.com/eslogin2020/images/btWelcome.png" />
            </Container>
            <br />                           
              <br />    
              
              <TextField  variant="outlined" id="userLogin" value={this.state.wcUser} ref="UserLogin" label="User: " onChange={e => this.setState({ wcUser: e.target.value })} />
              <br /><br />
              <TextField  id="userPass" ref="UserPass" label="Password: " type="password"  variant="outlined" onChange={e => this.setState({ wcPass: e.target.value })} />
              <br />
              <br />   
              {this.state.showBtLogin && (           
              <Button variant="contained" color="primary" onClick={this.handleClickLogin} >
                Login
              </Button> 
              )}
              <br />  
              <br />                 
              {this.state.showLoading && (              
              <CircularProgress color="inherit" />
              )}    
              <br />           
              <br />
              {this.state.currentFormURL}

              <br />
              <form method="post" action={this.state.currentFormURL}  style={{display:'none'}} > 
              <input type="text"  name="usuario"  value={this.state.wcUser} />
              <input type="text" name="pass"   value={this.state.wcPass}    />      
              <input type="submit" value="Submit" ref={this.inputWCStick} />
              </form>                              
          </div>
        );
      }
}
export default LoginWelcomeCenter;

